import React from 'react';
import { 
    FormControl, 
    FormGroup, 
    FormControlLabel, 
    Checkbox, 
    Typography
} from '@material-ui/core';
import { useLeakCheckForm } from './LeakCheckFormContext';

export const CustomerInfoSection: React.FC = () => {
    const { form, toggleCustomerInfoField } = useLeakCheckForm();
    
    if (!form) return null;
    
    return (
        <>
            <Typography variant="h6" gutterBottom>
                Customer Information Fields
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
                Select which customer information fields should be included in the form.
            </Typography>
            
            <FormControl component="fieldset">
                <FormGroup>
                    <FormControlLabel
                        control={<Checkbox 
                            checked={form.customerInfo.name} 
                            onChange={() => toggleCustomerInfoField('name')}
                            color="primary"
                        />}
                        label="Customer Name"
                    />
                    <FormControlLabel
                        control={<Checkbox 
                            checked={form.customerInfo.address} 
                            onChange={() => toggleCustomerInfoField('address')}
                            color="primary"
                        />}
                        label="Street Address"
                    />
                    <FormControlLabel
                        control={<Checkbox 
                            checked={form.customerInfo.city} 
                            onChange={() => toggleCustomerInfoField('city')}
                            color="primary"
                        />}
                        label="City"
                    />
                    <FormControlLabel
                        control={<Checkbox 
                            checked={form.customerInfo.state} 
                            onChange={() => toggleCustomerInfoField('state')}
                            color="primary"
                        />}
                        label="State"
                    />
                    <FormControlLabel
                        control={<Checkbox 
                            checked={form.customerInfo.zipCode} 
                            onChange={() => toggleCustomerInfoField('zipCode')}
                            color="primary"
                        />}
                        label="Zip Code"
                    />
                    <FormControlLabel
                        control={<Checkbox 
                            checked={form.customerInfo.phone} 
                            onChange={() => toggleCustomerInfoField('phone')}
                            color="primary"
                        />}
                        label="Phone Number"
                    />
                </FormGroup>
            </FormControl>
        </>
    );
};